import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import constant from '../../constant';
import { onChange, validateForm } from '../../utils';
import WithToastContext from '../../context/ToastContext';
import Loader from '../../component/common/Loader';
import { forgotPassword } from '../../action/_AuthAction';
import Logo from './../../assets/img/logo.png'
// import Poster1 from './../../assets/img/Happy family jumping with huge piggybank.jpg'

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);

        this.state = {
            email: { name: 'email', required: true, error: '', value: '', type: constant.fieldType.string },
            showLoader: false
        }
    }

    componentDidMount() {
        document.title = constant.component.forgotPassword.title;
    }

    render() {
        const { email, showLoader } = this.state;
        return (
            <div className="container-fluid">
                {
                    showLoader && <Loader />
                }
                <div className="row mt-5">
                    <div className="col-md-8 text-center mb-5" style={{ position: 'relative' }}>
                        <img src="/assets/img/Happy family jumping with huge piggybank.jpg" style={{ width: '80%' }} alt="" />
                        <div
                            style={{
                                fontSize: '1.2rem',
                                display: 'flex', justifyContent: 'space-evenly',
                            }}>
                            <span>
                                🔎 Track status of your loan in <b style={{ color: '#023c5b', borderBottom: '1px dashed' }}>Realtime</b>
                            </span>
                            <span>
                                📄 View <b style={{ color: '#023c5b', borderBottom: '1px dashed' }}>Documents</b> submitted for Loan Approval
                            </span>
                            <span>
                                👋 Get in touch with <b style={{ color: '#023c5b', borderBottom: '1px dashed' }}>Team</b> working on your Loan
                            </span>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="text-center mb-5">
                            <img src={Logo} className="w-50" alt="Capital Plus Residential" />
                        </div>
                        <div className=" b-shadow p-4" style={{ border: '0.1px solid #eeefff' }}>
                            <div className="">
                                <h5>Forgot Password</h5>
                                <hr />
                                <form onSubmit={this.onSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Email *</label>
                                        <input
                                            type="email"
                                            name={email.name}
                                            onChange={this.onChange}
                                            value={email.value}
                                            className={email.error.length === 0 ? "form-control" : "form-control is-invalid"}
                                        />
                                    </div>
                                    <div className="row mt-3 pt-3">
                                        <div className="col">
                                            <Link to={constant.component.login.url} className="btn btn-link">Back To Login</Link>
                                        </div>
                                        <div className="col text-right">
                                            <button className="btn btn-primary px-5" type="submit">Submit</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <div className="text-center mt-3">
                            Powered by <a href="https://capitalplusres.com" target="_blank" rel="noreferrer">Loan Tracker USA</a>
                        </div>
                    </div>
                    {/* <div className="col-md-4">
                        <img src={Poster2} style={{ width: '100%' }} />
                    </div> */}
                </div>
            </div>
        );
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const { email } = this.state;
            const model = {
                email: email.value,
            };
            this.setState({ showLoader: true });
            forgotPassword(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res.error) {
                    this.props.context.toast.error(res.error);
                } else {
                    this.props.context.toast.success('An email with relevant details has been sent to given email. Please check your email.');
                }
            })
        }
    }
}

export default WithToastContext(withRouter(ComponentName));
